import { render, staticRenderFns } from "./XhMultipleSelect.vue?vue&type=template&id=2b415f76&scoped=true"
import script from "./XhMultipleSelect.vue?vue&type=script&lang=js"
export * from "./XhMultipleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b415f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b415f76')) {
      api.createRecord('2b415f76', component.options)
    } else {
      api.reload('2b415f76', component.options)
    }
    module.hot.accept("./XhMultipleSelect.vue?vue&type=template&id=2b415f76&scoped=true", function () {
      api.rerender('2b415f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhMultipleSelect.vue"
export default component.exports